var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { on: { click: (event) => _vm.isOutside(event) } },
    [
      _c("modal", {
        staticClass: "modal-wrapper",
        attrs: { width: _vm.width, height: _vm.height },
        on: { "hide-modal": _vm.next },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "modal-inner px-2 w-full" },
                  [
                    _c("div", { staticClass: "pb-1/2" }, [
                      _c("div", { staticClass: "text-2xl font-bold pb-1/2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.title) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ]),
                    _vm._v(" "),
                    _c("UserForm", {
                      ref: "billing",
                      attrs: {
                        formModule: "billing",
                        formModel: { ..._vm.billing },
                        formSchema: _vm.editBillingFormSchema,
                        formPlaceholders: _vm.checkoutContent.formPlaceholders,
                        formHints: _vm.checkoutContent.formHints,
                        formValidationErrorMessages:
                          _vm.checkoutContent.validationErrorMessages,
                        formSelectFieldOptions: {},
                      },
                    }),
                    _vm._v(" "),
                    _vm.showBanner
                      ? _c("div", { staticClass: "banner" }, [
                          _c("div", { staticClass: "banner" }, [
                            _c("span", { staticClass: "font-bold" }, [
                              _vm._v("Incomplete Field(s): "),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Please make sure to fill out all of the information above. "
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ButtonSection", {
                      attrs: {
                        inputValid: true,
                        buttonText: _vm.buttonText,
                        buttonStyling: "justify-center",
                      },
                      on: { progress: _vm.submitHandler },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }